// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 1rem;
}

.auth-container {
  width: 100%;
  max-width: 28rem;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.auth-form-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: -0.5rem;
}

.auth-divider {
  position: relative;
  text-align: center;
  margin: 1.5rem 0;
}

.auth-divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #e5e7eb;
}

.auth-divider span {
  background: #ffffff;
  padding: 0 1rem;
  color: #6b7280;
  font-size: 0.875rem;
  position: relative;
  z-index: 1;
}

.auth-actions {
  text-align: center;
}

.auth-text {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.auth-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease-in-out;
}

.auth-link:hover {
  color: #5a67d8;
  text-decoration: underline;
}

.auth-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
}

.auth-alert span {
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.auth-alert div {
  flex: 1 1;
}

.auth-alert strong {
  display: block;
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.auth-alert p {
  margin: 0;
  line-height: 1.4;
}

.auth-alert-success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #166534;
}

.auth-alert-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
}

.auth-alert-error a:link,
.auth-alert-error a:visited,
.auth-alert-error a:hover {
  text-decoration: none;
  color: #991b1b;
}

.auth-alert-warning {
  background: #fffbeb;
  border: 1px solid #fed7aa;
  color: #92400e;
}

.password-input-container {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.25rem;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s ease-in-out;
}

.password-toggle:hover {
  background: rgba(0, 0, 0, 0.05);
}

.password-toggle:focus {
  outline: none;
  background: rgba(102, 126, 234, 0.1);
}

/* Upload Section Styles */
.upload-section {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1.5rem;
  background: #f9fafb;
}

.upload-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.5rem 0;
}

.upload-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0 0 1.5rem 0;
}

.upload-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.upload-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.upload-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}

.upload-dropzone {
  border: 2px dashed #d1d5db;
  border-radius: 0.5rem;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background: #ffffff;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-dropzone:hover {
  border-color: #667eea;
  background: #f8fafc;
}

.upload-dropzone-active {
  border-color: #667eea;
  background: #f0f9ff;
}

.upload-dropzone-error {
  border-color: #ef4444;
  background: #fef2f2;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.upload-placeholder span {
  font-size: 2rem;
}

.upload-placeholder p {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.upload-placeholder small {
  font-size: 0.75rem;
  color: #9ca3af;
}

.upload-file {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.upload-file span {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.upload-file div {
  flex: 1 1;
  text-align: left;
}

.upload-file strong {
  display: block;
  font-size: 0.875rem;
  color: #111827;
  margin-bottom: 0.25rem;
}

.upload-file p {
  margin: 0;
  font-size: 0.75rem;
  color: #6b7280;
}

.upload-error {
  font-size: 0.75rem;
  color: #ef4444;
  margin-top: 0.25rem;
}

/* Responsive */
@media (max-width: 640px) {
  .auth-page {
    padding: 1rem;
  }
  
  .auth-container {
    max-width: none;
  }
  
  .auth-form {
    gap: 1.25rem;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .upload-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .auth-alert {
    padding: 0.875rem;
    font-size: 0.8125rem;
  }
  
  .upload-section {
    padding: 1.25rem;
  }
  
  .upload-dropzone {
    padding: 1.25rem;
    min-height: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 2rem 1rem;\n}\n\n.auth-container {\n  width: 100%;\n  max-width: 28rem;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.auth-form-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: -0.5rem;\n}\n\n.auth-divider {\n  position: relative;\n  text-align: center;\n  margin: 1.5rem 0;\n}\n\n.auth-divider::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: #e5e7eb;\n}\n\n.auth-divider span {\n  background: #ffffff;\n  padding: 0 1rem;\n  color: #6b7280;\n  font-size: 0.875rem;\n  position: relative;\n  z-index: 1;\n}\n\n.auth-actions {\n  text-align: center;\n}\n\n.auth-text {\n  color: #6b7280;\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n.auth-link {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease-in-out;\n}\n\n.auth-link:hover {\n  color: #5a67d8;\n  text-decoration: underline;\n}\n\n.auth-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-size: 0.875rem;\n}\n\n.auth-alert span {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.auth-alert div {\n  flex: 1;\n}\n\n.auth-alert strong {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-weight: 600;\n}\n\n.auth-alert p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n.auth-alert-success {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  color: #166534;\n}\n\n.auth-alert-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n}\n\n.auth-alert-error a:link,\n.auth-alert-error a:visited,\n.auth-alert-error a:hover {\n  text-decoration: none;\n  color: #991b1b;\n}\n\n.auth-alert-warning {\n  background: #fffbeb;\n  border: 1px solid #fed7aa;\n  color: #92400e;\n}\n\n.password-input-container {\n  position: relative;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.25rem;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.password-toggle:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.password-toggle:focus {\n  outline: none;\n  background: rgba(102, 126, 234, 0.1);\n}\n\n/* Upload Section Styles */\n.upload-section {\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  background: #f9fafb;\n}\n\n.upload-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 0.5rem 0;\n}\n\n.upload-subtitle {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin: 0 0 1.5rem 0;\n}\n\n.upload-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.upload-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.upload-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.upload-dropzone {\n  border: 2px dashed #d1d5db;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  background: #ffffff;\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.upload-dropzone:hover {\n  border-color: #667eea;\n  background: #f8fafc;\n}\n\n.upload-dropzone-active {\n  border-color: #667eea;\n  background: #f0f9ff;\n}\n\n.upload-dropzone-error {\n  border-color: #ef4444;\n  background: #fef2f2;\n}\n\n.upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.upload-placeholder span {\n  font-size: 2rem;\n}\n\n.upload-placeholder p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.upload-placeholder small {\n  font-size: 0.75rem;\n  color: #9ca3af;\n}\n\n.upload-file {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.upload-file span {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.upload-file div {\n  flex: 1;\n  text-align: left;\n}\n\n.upload-file strong {\n  display: block;\n  font-size: 0.875rem;\n  color: #111827;\n  margin-bottom: 0.25rem;\n}\n\n.upload-file p {\n  margin: 0;\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.upload-error {\n  font-size: 0.75rem;\n  color: #ef4444;\n  margin-top: 0.25rem;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .auth-page {\n    padding: 1rem;\n  }\n  \n  .auth-container {\n    max-width: none;\n  }\n  \n  .auth-form {\n    gap: 1.25rem;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .upload-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .auth-alert {\n    padding: 0.875rem;\n    font-size: 0.8125rem;\n  }\n  \n  .upload-section {\n    padding: 1.25rem;\n  }\n  \n  .upload-dropzone {\n    padding: 1.25rem;\n    min-height: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
